import { Div, RefBool, Range } from '@tblabs/truffle';
import { Icons } from '../Utils/Icons';
import { PlaybackModeSelector } from './PlaybackModeSelector';
import { SvgButton } from './SvgButton';
import { PlayerLogic } from './PlayerLogic';
import { VolumeControler } from './VolumeControler';


export class PlaybackControler extends Div
{
    constructor(_playerLogic: PlayerLogic)
    {
        super();
        const showVolumeControler = new RefBool().Storable("show-volume-controler");

        this.Append(
            new Range(_playerLogic.StartAt).Max(_playerLogic.Duration).WidthPercent(100),
            new Div().Style(`flex: 0; display: flex; align-items: center; justify-content: space-between; gap: 8px; padding: 8px;`).Append(
                new PlaybackModeSelector(_playerLogic.PlaybackMode),
                new Div().Style(`display: flex; align-items: center; justify-content: center; gap: 8px;`).Append(
                    new SvgButton(Icons.ChevronLeft).OnClick(() => _playerLogic.PlayPreviousSong()),
                    new SvgButton(Icons.Pause).OnClick(() => _playerLogic.PauseMusic())
                        .Visible(_playerLogic.IsPlaying),
                    new SvgButton(Icons.Play).OnClick(async () => await _playerLogic.Play())
                        .Invisible(_playerLogic.IsPlaying),
                    new SvgButton(Icons.ChevronRight).OnClick(() => _playerLogic.PlayNextSong())
                ),
                new SvgButton(Icons.Volume).OnClick(() => showVolumeControler.Toggle())
            ),
            new VolumeControler(_playerLogic.Volume, showVolumeControler)
                .Visible(showVolumeControler)
        );
    }
}
